import React, { Component } from "react";
import PropTypes from "prop-types";
import InputGroupStyled from "./InputGroup.styled";

export default class InputGroup extends Component {
    render() {
        // destructuring props
        const { children, classes } = this.props;
        return <InputGroupStyled className={classes}>{children}</InputGroupStyled>;
    }
}

// props validation
InputGroup.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.string
};
